"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectDefinition = getObjectDefinition;
exports.getPhysicsOptions = getPhysicsOptions;
const duckBurst_1 = require("./duckBurst");
const duck_1 = require("./duck");
const apple_1 = require("./apple");
const balloonMaterials_1 = require("./balloonMaterials");
const watermelon_1 = require("./watermelon");
const hotAirFire_1 = require("./hotAirFire");
const paintBalloon_1 = require("./paintBalloon");
const physicsOptions_1 = require("./physicsOptions");
const latexBalloon_1 = require("./latexBalloon");
const bubble_1 = require("./bubble");
const hotAirBalloon_1 = require("./hotAirBalloon");
const definitions = {
    duck: {
        draw: duck_1.drawDuck, spriteKey: object => [object.color, object.duckVariant], spriteHeight: 2.4,
        hitRadiusRatio: 1, popAtMax: false,
        physics: { appleImpactBreakSpeed: 1500, releaseImpulse: 0, collisionRadiusRatio: 0.8, collisionRestitution: 0.25 },
        updatePhysics: duck_1.updateDuck, constrain: duck_1.constrainDuck,
        onPop: duckBurst_1.burstDuck, updatePopped: duckBurst_1.updateDuckBurst, drawPopped: duckBurst_1.drawDuckBurst,
        isFinished: object => object.popTime >= duckBurst_1.DUCK_BURST_DURATION
    },
    apple: {
        draw: apple_1.drawApple, spriteRevision: apple_1.appleSpriteRevision, spriteKey: () => null,
        spriteHeight: 2.4, hitRadiusRatio: 0.9, popAtMax: false,
        physics: { appleImpactBreakSpeed: 1700, releaseImpulse: 0, collisionRadiusRatio: 0.9, collisionRestitution: 0.25 },
        updatePhysics: apple_1.updateApple, constrain: apple_1.constrainApple
    },
    watermelon: {
        draw: watermelon_1.drawWatermelon, spriteRevision: watermelon_1.watermelonSpriteRevision, spriteKey: () => null, spriteHeight: 2.3, hitRadiusRatio: 1,
        popAtMax: false, physics: watermelon_1.watermelonPhysics,
        updatePhysics: watermelon_1.updateWatermelon, constrain: watermelon_1.constrainWatermelon,
        onPop: watermelon_1.smashWatermelon, updatePopped: watermelon_1.updateWatermelonChunks,
        drawPopped: watermelon_1.drawWatermelonChunks, isFinished: object => object.popTime >= 1.8
    },
    paint: {
        draw: paintBalloon_1.drawPaintBalloon,
        spriteRevision: () => (0, balloonMaterials_1.materialRevision)("latex"),
        spriteKey: object => object.color,
        spriteHeight: 2.4,
        popAtMax: true,
        hitRadiusRatio: 0.94,
        physics: { ...paintBalloon_1.paintPhysics, appleImpactBreakSpeed: 450 },
        onPop: paintBalloon_1.popPaintBalloon
    },
    latex: {
        draw: latexBalloon_1.drawLatexVector,
        spriteRevision: () => (0, balloonMaterials_1.materialRevision)("latex"),
        spriteKey: object => [object.color, object.foil],
        spriteHeight: 2.4,
        popAtMax: false,
        physics: latexBalloon_1.latexPhysics
    },
    bubble: {
        draw: bubble_1.drawBubbleVector,
        spriteKey: bubble_1.bubbleFrame,
        spriteHeight: 2.3,
        popAtMax: true,
        physics: { ...bubble_1.bubblePhysics, appleImpactBreakSpeed: 180 }
    },
    'hot-air': {
        draw: hotAirBalloon_1.drawHotAirVector,
        spriteRevision: () => (0, balloonMaterials_1.materialRevision)("fabric"),
        spriteKey: object => [object.color, object.panelColors, object.panelCount],
        spriteHeight: 2.4,
        hitRadiusRatio: 0.94,
        popAtMax: false,
        physics: { ...hotAirBalloon_1.hotAirPhysics, appleImpactBreakSpeed: 900 },
        onPop: hotAirFire_1.igniteHotAir,
        updatePopped: hotAirFire_1.updateHotAirFire,
        isFinished: object => object.fire?.removed ?? true
    }
};
function getObjectDefinition(finish) {
    return definitions[finish];
}
/** Precedence: shared defaults < scene settings < type overrides < instance overrides. */
function getPhysicsOptions(object, scene = {}) {
    return {
        ...physicsOptions_1.defaultPhysicsOptions,
        ...scene,
        ...getObjectDefinition(object.finish).physics,
        ...object.physics
    };
}
//# sourceMappingURL=objectDefinitions.js.map